import React, { useEffect, useState } from 'react';
import { useCollection } from '@nandorojo/swr-firestore';
import { RootPath } from '@routes/routePath';
import styled from 'styled-components';
import { ISimejiItem, IsimejiScript } from '../simejiStatus.interface';
import useSetRandomTimer from '@hooks/useSetRandomTimer';
import Theme from '@styles/Theme';

const Balloon = styled.div`
  padding: 8px;
  border-radius: var(--cardBorderRadius);
  background: var(--cardBackgroundColor);
  border: 1px solid var(--cardLineColor);
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
  font-size: 12px;
  box-shadow: ${Theme.shadow.dropdown};
  z-index: 10;

  &:after {
    content: '';
    position: absolute;
    bottom: -6px; /* 말꼬리 위치 조정 (경계선 포함) */
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-width: 10px 10px 0 10px;
    border-style: solid;
    border-color: var(--cardBackgroundColor) transparent transparent transparent; /* 말풍선의 배경색과 맞추기 */
    z-index: 0; /* 말풍선 내부 내용과 말꼬리의 z-index 조정 */
  }

  &:before {
    content: '';
    position: absolute;
    bottom: -7.5px; /* 말꼬리의 경계선을 위한 위치 조정 */
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-width: 7.5px 7.5px 0 7.5px;
    border-style: solid;
    border-color: var(--cardLineColor) transparent transparent transparent; /* 말풍선의 경계색과 맞추기 */
    z-index: -1; /* 말풍선의 배경과 말꼬리 경계의 z-index 조정 */
  }
`;

type Props = {
  data: ISimejiItem;
  setCustomFace: any;
  isImageType?: boolean;
};
function SimejiScript({ data, setCustomFace, isImageType }: Props) {
  const collectionPath = RootPath.Simeji;

  const { data: scriptList } = useCollection<IsimejiScript>(
    `${collectionPath}/${data.id}/scripts`,
  );

  const [randomData] = useSetRandomTimer({
    randomList: scriptList || [],
    timer: 5000,
  });

  useEffect(() => {
    if (!randomData || isImageType) return;
    if (!randomData.eyes || !randomData.eyebrow) return;
    setCustomFace((prev) => ({
      ...prev,
      eyes: randomData.eyes,
      eyebrow: randomData.eyebrow,
    }));
  }, [randomData, isImageType]);

  if (!randomData || !randomData.contents) return null;

  return (
    <Balloon
      dangerouslySetInnerHTML={{
        __html: randomData.contents || '',
      }}
    ></Balloon>
  );
}

export default SimejiScript;
